import React from "react";
import {
  EdhProtocolAttributePageContent,
  EdhProtocolAttributePageStateProvider,
} from ".";

export const EdhProtocolAttributePage = () => {
  return (
    <>
      <EdhProtocolAttributePageStateProvider>
        <EdhProtocolAttributePageContent></EdhProtocolAttributePageContent>
      </EdhProtocolAttributePageStateProvider>
    </>
  );
};
